import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactNode } from "react"

import { WagmiProvider as _WagmiProvider } from "wagmi"

import { createConfig } from "wagmi"
import { chains, transports } from "util/wagmiConfig"

import { getDefaultConfig } from "connectkit"

/**
 * WalletConnect v2 project ID
 */
const projectId = "1c3b64d40de34f18b135f597aae251fa"

const WagmiProvider = ({ children }: { children: ReactNode }) => {
  const queryClient = new QueryClient()

  const config = createConfig(
    getDefaultConfig({
      chains,
      transports,

      // Required API Keys
      walletConnectProjectId: projectId,

      // Required App Info
      appName: "Paragraph",

      // Optional App Info
      appDescription: "A new home for great writing.",
      appUrl: "https://paragraph.xyz", // your app's url
      appIcon: "https://paragraph.xyz/branding/logo_no_text.png", // your app's icon, no bigger than 1024x1024px (max. 1MB)
    })
  )

  return (
    <_WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </_WagmiProvider>
  )
}

export default WagmiProvider
